/**
 * Created by stefan on 10/5/2016.
 */
export default rbMatch;
function rbMatch() {

  return {
    restrict: 'A',
    require: '?ngModel',
    scope:{
      rbMatch:'='
    },
    link: ($scope, $elem, $attr, ngModel)=> {
      function validator(value) {
        // noinspection EqualityComparisonWithCoercionJS
        const v = value == $scope.rbMatch;
        //console.log(value +' '+ $scope.rbMatch);
        ngModel.$setValidity('rbmatch',v);
        return value;
      }
      ngModel.$parsers.unshift(validator);
      ngModel.$formatters.push(validator);
      $scope.$watch('rbMatch', function () {
        validator(ngModel.$viewValue);
      });
    }
  }
}







